export const version = 'kunde-v1.20.0-SNAPSHOT-80fedc7d9089fd1fbcdbac61a0e42ee542e8c369';